class GoogleDataLayerProvider {
    constructor(orderData = {}, productData = {}, sessionData = {}) {

        const googleDataLayerDefaults = {
            cartItems: [],
            fees: []
        };

        this.data = Object.assign(googleDataLayerDefaults, orderData);

        this.productData = productData;

        this.sessionData = sessionData;
    }

    getSession() {

        const sessionData = this.sessionData;

        return {
            session: {
                key: sessionData.sessionKey,
                isRenewalOrder: sessionData.isRenewalOrder,
                modeOfSale: sessionData.modeOfSale,
                sourceId: sessionData.sourceId,
                version: window.tnew.app.appVersion.toString(),
                isVersionSevenEnabled: true,
                customer: {
                    id: sessionData.customerNumber,
                    isGuest: sessionData.isGuest,
                    isAnonymous: sessionData.isAnonymous
                }
            }
        };
    }

    getProduct() {

        const product = this.productData;

        return {
            product: {
              productTypeDescription: product.productTypeDescription,
              productionSeasonId: product.productionSeasonId,
              performanceId: product.performanceId,
              packageId: product.packageId,
              contributionTypeId: product.contributionTypeId,
              fundId: product.fundId,
              onAccountPaymentMethodId: product.onAccountPaymentMethodId,
              giftCertificatePaymentMethodId: product.giftCertificatePaymentMethodId
            }
        }
    }

    transformOrder() {

        if (this.data.cartItems.length === 0) {
            return {}
        }

        const convertedProducts = this.convertProducts();
        const totalFees = this.sumFees();
        const data = this.data;

        return {
            transactionId: data.number,
            transactionAffiliation: data.modeOfSale,
            transactionTotal: data.total,
            transactionTax: 0,
            transactionProducts: convertedProducts,
            transactionShipping: totalFees
        };
    }

    convertProducts() {
        const products = {};
        const cartItems = this.data.cartItems;

        cartItems.forEach((cartItem) => {

            const key = `${cartItem.productId}-${cartItem.priceType}-${cartItem.price}`;

            if (products[key]) {

                products[key].quantity += cartItem.quantity;

            } else {

                products[key] = {
                    sku: this.buildSku(cartItem),
                    name: cartItem.productDescription,
                    category: cartItem.productType,
                    price: cartItem.price,
                    quantity: cartItem.quantity
                };
            }
        });

        return Object.values(products);
    }

    sumFees() {
        return this.data.fees.reduce((sum, fee) => sum + fee.amount, 0);
    }

    buildSku(cartItem) {

        if (cartItem.productType === 'Contribution') {
            return `${cartItem.productId}|${cartItem.id}`;
        }

        const id = (cartItem.productId) ? cartItem.productId : cartItem.id;
        const skuElements = [id, cartItem.priceTypeDescription, cartItem.priceType, cartItem.price];

        return skuElements.filter(el => !!el).join('|');
    }
}

export default GoogleDataLayerProvider;



// WEBPACK FOOTER //
// ./V7/tnew/lib/GoogleDataLayerProvider.js